export { default } from "./Footer"
